import { c as _c } from "react/compiler-runtime";
export const FingerprintIcon = t0 => {
  const $ = _c(11);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" />;
    t2 = <path d="M14 13.12c0 2.38 0 6.38-1 8.88" />;
    t3 = <path d="M17.29 21.02c.12-.6.43-2.3.5-3.02" />;
    t4 = <path d="M2 12a10 10 0 0 1 18-6" />;
    t5 = <path d="M2 16h.01" />;
    t6 = <path d="M21.8 16c.2-2 .131-5.354 0-6" />;
    t7 = <path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" />;
    t8 = <path d="M8.65 22c.21-.66.45-1.32.57-2" />;
    t9 = <path d="M9 6.8a6 6 0 0 1 9 5.2v2" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] !== className) {
    t10 = <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}</svg>;
    $[9] = className;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};
export function RateNicButton(t0) {
  const $ = _c(2);
  const {
    onRateClick
  } = t0;
  let t1;
  if ($[0] !== onRateClick) {
    t1 = <button type="button" onClick={onRateClick} className="tw-flex tw-flex-shrink-0 tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-lg tw-border tw-border-solid tw-border-emerald-600 tw-bg-emerald-600 tw-px-3 tw-py-2 tw-text-xs tw-font-bold tw-text-white tw-transition tw-duration-300 tw-ease-out hover:tw-border-emerald-500 hover:tw-bg-emerald-500">Rate NIC</button>;
    $[0] = onRateClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}